<template>
  <ContentSection>
    <Container class="grid w-full max-md:gap-6 md:grid-cols-2">
      <!-- TEXT -->
      <div
        class="flex flex-col justify-center md:py-5"
        :class="imagePosition === 'right' ? 'order-1 md:pr-12 xl:pr-18' : 'order-2 md:pl-12 xl:pl-18'"
      >
        <!-- Title -->
        <h2
          v-if="data.heading"
          v-animate-in-from-bottom
          class="mb-5 typo-heading-md lg:typo-heading-3xl"
          v-html="data.heading"
        />

        <!-- Text -->
        <div v-animate-in-from-bottom class="mb-5 typo-body-xl link lg:typo-body-2xl md:mb-8" v-html="data.text" />

        <!-- Link -->
        <div v-animate-in-from-left>
          <AppLink
            v-if="data.link_text"

            :to="data.link"
          >
            {{ data.link_text }}
          </AppLink>
        </div>
      </div>

      <!-- IMAGE -->
      <div :class="imagePosition === 'right' ? 'order-2' : 'order-1'">
        <div
          v-animate-zoom-in
          class="aspect-[516/431] max-h-[60vh]"
        >
          <AppImage
            v-if="data.image"
            :src="data.image"
            :alt="useMapAltText(data.image)"
            class="size-full object-cover"
            :class="imagePosition === 'right' ? 'rounded-tr-100' : 'rounded-tl-100'"
          />
        </div>
      </div>
    </Container>
  </ContentSection>
</template>

<script lang="ts" setup>
import type { ComponentsMainTeaserGeneralFragment } from '#gql'

const props = defineProps<{
  data: Enforce<ComponentsMainTeaserGeneralFragment>
  prevComponent?: string | null
  nextComponent?: string | null
}>()

const imagePosition = computed(() => {
  return props.data.image_position?.value === 'right' ? 'right' : 'left'
})
</script>
